//global.jQuery = require('jquery');
import Foundation from 'foundation-sites';
Foundation.addToJquery(jQuery);